/* eslint-disable guard-for-in */
angular.module('tgaAdmin').controller('InstructorGameController', [
  '$scope',
  '$state',
  '$location',
  '$filter',
  '$timeout',
  '$window',
  '$document',
  'gameService',
  'instructorService',
  'userService',
  '$sce',
  'settingsService',
  'modalService',
  'game',
  'urlService',
  '$rootScope',
  'socketService',
  'VILTWebsocketActionsService',
  'StreamService',
  'envService',
  '$log',
  function (
    $scope,
    $state,
    $location,
    $filter,
    $timeout,
    $window,
    $document,
    gameService,
    instructorService,
    userService,
    $sce,
    settingsService,
    modalService,
    game,
    urlService,
    $rootScope,
    socketService,
    VILTWebsocketActionsService,
    StreamService,
    envService,
    $log,
  ) {
    $scope.showBack = true;
    $scope.pollingEnabled = true;
    $scope.clueIncludedTooltip = $filter('translate')('instructor.clue_included');
    // flag set if instructor triggers the end of the VILT game
    $scope.triggeredGameEnd = false;
    // step one of setting up the websocket service, give it all the default functions
    $scope.VILTSocketService = { ...VILTWebsocketActionsService.standard };
    $scope.data = {
      gameId: $state.params.game_id || null,
      url: urlService.composeProtocolHostPort($location),
      gameUrl: null,
      gameTypes: gameService.getGameTypes(),
      finalQuestionId: null,
      dailyDoubles: [],
      muteGame: false,
      yesno: [
        {
          id: 'virtual',
          name: 'Virtual',
        },
        {
          id: 'live',
          name: 'In-person',
        },
      ],
    };

    $scope.viewmodel = {
      slug: $state.params.slug,
      name: null,
      mode: 'virtual',
      game: angular.copy(game),
      currentQuestion: null,
      session_group_id: null,
      totalPlayers: 0,
      currentPlayersAnswered: 0,
      currentPlayersCorrect: 0,
      totalQuestions: 0,
      session_data: {},
      questions: {},
      question_answers: {},
      disableInstructorInteraction: false,
      history: {
        session_group_id: null,
        players: [],
        questions: [],
      },
    };

    // using this to enforce a retrigger of instructor button delay
    // needed right now to retrigger show answers button delay
    // since it can live side-by-side with show clue if there is an image
    $scope.forceInstructorButtonDisable = false;
    $scope.triggerIntructorButtonDelay = () => {
      $timeout(() => {
        $scope.forceInstructorButtonDisable = true;
      }).then(() => {
        $timeout(() => {
          $scope.forceInstructorButtonDisable = false;
        });
      });
    };

    $scope.isGameType = (types = []) => {
      // put value into Array if array isn't passed
      const toCheck = !angular.isArray(types) ? [types] : types;
      return toCheck.includes($scope.viewmodel.game.game_type);
    };

    $scope.initialize = function () {
      $scope.loading = true;

      if ($scope.viewmodel.game.game_mode === 'standard') {
        $window.history.back();
        return;
      }

      $scope.title = `<span class="text-muted">Instructor / ${$scope.viewmodel.game.name} / </span> New Session`;
      $scope.data.gameType = $scope.viewmodel.game.game_type;

      // Collect and count questions.
      $scope.viewmodel.questions = $scope.collectQuestionsFromGame($scope.viewmodel.game);
      $scope.viewmodel.totalQuestions = Object.keys($scope.viewmodel.questions).length;

      // Collect answers for questions.
      $scope.viewmodel.question_answers = $scope.collectAnswersFromQuestions($scope.viewmodel.questions);

      switch ($scope.data.gameType) {
        // need to inject jeopardy socket functions
        case 'jeopardy':
          $scope.totalQuestionsJeopardy = Object.keys($scope.viewmodel.questions).length;
          if (!$scope.viewmodel.game.double_jeopardy) {
            for (let i = 0; i < $scope.viewmodel.game.question_groups[1].question_groups.length; i++) {
              $scope.totalQuestionsJeopardy
                -= $scope.viewmodel.game.question_groups[1].question_groups[i].questions.length;
            }
          }
          $scope.VILTSocketService = {
            ...$scope.VILTSocketService,
            ...VILTWebsocketActionsService.jeopardy,
          };
          break;
        case 'wbs':
          $scope.viewmodel.WBS = $scope.processWBSGameMeta($scope.viewmodel.game.meta);
          $scope.viewmodel.WBS.history = $scope.processWBSGameMeta($scope.viewmodel.game.meta);
          break;
        default:
          break;
      }

      const gameType = $filter('filter')(
        $scope.data.gameTypes,
        {
          key: $scope.data.gameType,
        },
        true,
      )[0] || {};

      $scope.data.gameTypeName = gameType.name;
      if ($scope.viewmodel.slug) {
        instructorService
          .addInstructor($scope.viewmodel.slug)
          .then(({ game_state, instructor_token }) => {
            $scope.initializeInstructorSocket($scope.viewmodel.slug, instructor_token);
            $scope.setState(game_state);
            $scope.setGameUrl(game_state, instructor_token);
            $scope.refreshInstructorState(game_state);
            $scope.viewmodel.name = game_state.name;
            $scope.viewmodel.mode = game_state.mode;

            if ($scope.data.gameType === 'jeopardy') {
              $scope.data.finalQuestionId = _.get($scope.viewmodel.game.question_groups, [
                2,
                'question_groups',
                0,
                'questions',
                0,
                'question_id',
              ]);
              $scope.data.dailyDoubles = [];

              const coords = _.get(game_state, 'coords');
              if (angular.isArray(coords)) {
                coords.filter(angular.isArray).forEach(([x, y], index) => {
                  const group_id = index === 0 ? 0 : 1;
                  const question_id = _.get($scope.viewmodel.game.question_groups, [
                    group_id,
                    'question_groups',
                    x,
                    'questions',
                    y,
                    'question_id',
                  ]);
                  if (question_id != null) {
                    $scope.data.dailyDoubles.push(question_id);
                  }
                });
              }
            }
          })
          .finally(() => {
            $scope.loading = false;
            if (VILTWebsocketActionsService.getSocket()) {
              VILTWebsocketActionsService.standard.getState();
              VILTWebsocketActionsService.standard.getLiveSession();
            }
          });
      }

      settingsService.getSettings().then((settings) => {
        $scope.data.settings = settings;
      });
    };

    /**
     * Recursively scour a game for questions.
     * @returns {Object} containing questions keyed by question_id
     */
    $scope.collectQuestionsFromGame = function (gameObj) {
      // Fall back to local game
      gameObj ??= $scope.viewmodel.game;

      // Inner recursive function
      function extractQuestions(acc, { questions, question_groups }) {
        // Extract questions
        _.forEach(questions, (question) => {
          if (_.has(question, 'question_id')) {
            acc[question.question_id] = question;
          }
        });

        // Recurse into question groups
        _.forEach(question_groups, (questionGroup) => extractQuestions(acc, questionGroup));

        return acc;
      }

      return extractQuestions({}, gameObj);
    };

    $scope.collectAnswersFromQuestions = function (questions) {
      // Cast object to array and fall back to local scope/game questions
      if (_.isPlainObject(questions)) {
        questions = Object.values(questions);
      } else if (questions == null) {
        questions = Object.values($scope.viewmodel.questions || $scope.collectQuestionsFromGame());
      }

      function extractAnswers(acc, qaArray) {
        return _.reduce(
          qaArray,
          (a, { answers }) => {
            _.forEach(answers, (answer) => {
              if (_.has(answer, 'answer_id')) {
                a[answer.answer_id] = answer;
              }
            });
            return a;
          },
          acc,
        );
      }

      return extractAnswers({}, questions);
    };

    $scope.setState = function (game_state) {
      if (game_state) {
        if ($scope.viewmodel.session_group_id !== game_state.session_group_id) {
          $scope.viewmodel.session_group_id = game_state.session_group_id;
        }
        $scope.viewmodel.game.game_state = game_state;
        $scope.viewmodel.slug = game_state.slug;
        $scope.visibility.calculateVariables();
      }
    };

    $scope.setGameUrl = function (game_state, instructor_token = '') {
      $scope.viewmodel.game.slug = game_state.slug;

      // TODO: DONT LEAVE LIKE THIS
      const override = envService.read('gameUrlOverride');
      let gameUrl = override ? `${override}${$scope.viewmodel.slug}` : gameService.getGameUrl($scope.viewmodel.game);

      // eslint-disable-next-line max-len
      gameUrl = `${gameUrl + (gameUrl.indexOf('?') !== -1 ? '&' : '?')}instructor=true&bypass_reg=true&username=${
        encodeURIComponent(userService.getUserData().username)
      }&instructor_token=${instructor_token}`;
      $scope.data.gameUrl = $sce.trustAsResourceUrl(gameUrl);
    };

    $scope.refreshInstructorState = function (game_state) {
      $scope.viewmodel.game.game_state = {
        ...$scope.viewmodel.game.game_state,
        ...game_state,
      };
      if ($scope.viewmodel.game.game_state.question_id) {
        // Check if current question just changed
        const old_question_id = $scope.viewmodel.currentQuestion?.question_id;
        const new_question_id = $scope.viewmodel.game.game_state.question_id;
        if (old_question_id !== new_question_id) {
          // Close old accordion
          if ($scope.viewmodel.questions[old_question_id] != null) {
            $scope.viewmodel.questions[old_question_id].isOpen = false;
          }
          // Open new accordion
          if ($scope.viewmodel.questions[new_question_id] != null) {
            $scope.viewmodel.questions[new_question_id].isOpen = true;
          }
        }

        // Set current question
        $scope.viewmodel.currentQuestion = $scope.viewmodel.questions[new_question_id];
      } else {
        $scope.viewmodel.currentQuestion = null;
      }
      $scope.visibility.calculateVariables();
    };

    /**
     * Update session, player, answer status.
     */
    $scope.updateSessionStatus = async function (new_session_data) {
      $scope.processSessionData(new_session_data);
      if ($scope.data.gameType === 'wbs') {
        $scope.formatWBS($scope.viewmodel.WBS);
      } else if ($scope.data.gameType === 'jeopardy') {
        $scope.formatCurrentWagers();
      }
      // cancel any outstanding session update $timeouts
      $timeout.cancel($scope.sessionUpdateTimeout);
      // request live session status again
      $scope.sessionUpdateTimeout = $timeout(() => $scope.updateSessionStatus(StreamService.getLiveSession()), 3000);
    };

    /**
     * Process a new live session data.
     * Generates and/or updates existing session, player, and answer data for display.
     */
    $scope.processSessionData = function (new_session_data) {
      // Ensure $scope session data object exists
      if (!_.isPlainObject($scope.viewmodel.session_data)) {
        $scope.viewmodel.session_data = {};
      }
      const { session_data } = $scope.viewmodel;

      /**
       * Session group data
       */

      // Shallow merge into existing object to maintain reference for angular bindings.
      const session_group = _.assign(session_data.session_group, new_session_data.session_group);

      /**
       * Player sessions array
       */

      // Ensure $scope player_sessions array exists.
      if (!angular.isArray(session_data.player_sessions)) {
        session_data.player_sessions = [];
      }

      // Determine if last name is required registration field
      const { fields } = $scope.viewmodel.game.registration;
      const lastNameRequired = fields.filter((f) => f.key === 'last_name' && f.condition === 'required').length > 0;

      // Loop over player_sessions:
      // * Filter out instructor and/or session creator.
      // * Set up derived stats variables.
      const instructor_id = _.toInteger(session_group.game_state?.instructor_id);
      const session_group_created_by = _.toInteger(session_group?.created_by);
      const player_sessions = _.filter(new_session_data.player_sessions, (player) => {
        if (_.toInteger(player.user_id) === instructor_id || player.user_id === session_group_created_by) {
          return false; // Filter
        }

        player.answers = {};
        player.current_answer = null;
        player.total_answered = 0;
        player.total_correct = 0;
        // if last name is a required registration field the append to the display name
        if (lastNameRequired && !player.display_name.endsWith(` ${player.last_name}`)) {
          player.display_name += ` ${player.last_name}`;
        }
        return true;
      });

      // Sort sessions DESCENDING by high score and ASCENDING by total answer time (for rank)
      player_sessions.sort((a, b) => {
        const aHasScore = angular.isNumber(a.high_score);
        const bHasScore = angular.isNumber(b.high_score);
        if (aHasScore && bHasScore) {
          return (b.high_score - a.high_score) || (a.answer_time - b.answer_time);
        }
        return bHasScore ? 1 : -1;
      });

      // Update score & rank on sessions.
      player_sessions.forEach((player, index) => {
        let playerScore = player.high_score;
        let playerRank = player.rank;
        if (!angular.isNumber(playerScore)) {
          playerScore = 'N/A';
          playerRank = 'N/A';
        } else {
          playerRank = index + 1;
        }
        // If score or rank changed, replace object with copy so that Angular recognizes the change.
        if (playerScore !== player.high_score || playerRank !== player.rank) {
          player_sessions[index] = {
            ...player,
            high_score: playerScore,
            rank: playerRank,
          };
        }
      });

      // Replace contents of existing array to maintain reference for angular bindings.
      session_data.player_sessions.splice(0, session_data.player_sessions.length, ...player_sessions);

      /**
       * Player session keyed lookup by session_id
       */

      // Ensure $scope player_sessions_lookup array exists
      if (!_.isPlainObject(session_data.player_sessions_lookup)) {
        session_data.player_sessions_lookup = {};
      }

      // Shallow merge into existing object to maintain reference for angular bindings.
      const player_sessions_lookup = _.assign(
        session_data.player_sessions_lookup,
        _.keyBy(session_data.player_sessions, 'session_id'),
      );

      /**
       * Player answers data
       */

      // Ensure $scope player_answers array exists
      if (!_.isPlainObject(session_data.player_answers)) {
        session_data.player_answers = [];
      }

      // We will use these below for grouping player answers.
      const tempGroupMap = {};
      const tempGroups = [];

      // Loop over player_answers:
      // * Filter answers from missing or filtered players.
      // * Add references to related fields.
      // * Group answers by question.
      const player_answers = _.filter(new_session_data.player_answers, (player_answer) => {
        // Add player object reference to each player answer
        const player = player_sessions_lookup[player_answer.session_id];
        player_answer.player = player;

        if (player == null) {
          return false; // Filter
        }

        // Add answer object reference(s) if relevant
        player_answer.answers = [];
        if (player_answer.answer_id > 0) {
          player_answer.answers.push($scope.viewmodel.question_answers[player_answer.answer_id]);
        }
        if (angular.isString(player_answer.answer_answer_ids)) {
          _.forEach(player_answer.answer_answer_ids.split(','), (answer_id) => {
            player_answer.answers.push($scope.viewmodel.question_answers[answer_id]);
          });
        }

        // Collect player answers into groups by question id (using array to maintain order)
        const { question_id } = player_answer;
        let tempGroup = tempGroupMap[question_id];
        if (tempGroup == null) {
          tempGroup = tempGroupMap[question_id] = {
            index: tempGroups.length + 1,
            question_id,
            answers: [],
          };
          tempGroups.push(tempGroup);
        }
        tempGroup.answers.push(player_answer);

        // Update player stats
        player.answers[player_answer.question_id] = player_answer;
        player_answer.player.total_answered++;
        if (player_answer.correct) {
          player_answer.player.total_correct++;
        }

        return true;
      });

      // Replace contents of existing array to maintain reference for angular bindings.
      session_data.player_answers.splice(0, session_data.player_answers.length, ...player_answers);

      /**
       * Grouped answer data keyed by question
       */

      // Ensure $scope answer_groups object exists
      if (!_.isPlainObject(session_data.answer_groups)) {
        session_data.answer_groups = {};
      }
      const { answer_groups } = session_data;

      // Ensure $scope answer_groups_desc object exists
      if (!_.isPlainObject(session_data.answer_groups_desc)) {
        session_data.answer_groups_desc = {};
      }
      const { answer_groups_desc } = session_data;

      // Reset object properties (to reset sort order)
      _.forEach(answer_groups_desc, (val, key, obj) => delete obj[key]);

      // Loop over grouped player_answers (* number of questions):
      // * Populate answer_groups object with set of answer groups keyed by question_id.
      // * Iterate from right to facilitate populating descending-sorted group object.
      _.forEachRight(tempGroups, ({ index, question_id, answers }) => {
        // Ensure group object for question exists
        if (!_.isPlainObject(answer_groups[question_id])) {
          answer_groups[question_id] = {};
        }
        const group = answer_groups[question_id];

        // Set descending-sorted group object.
        // We are depending on insertion order inside the object, so cannot use plain-number keys.
        answer_groups_desc[`q${question_id}`] = group;

        // Set ascending order numeric index
        group.index = index;

        // Set question reference
        group.question = $scope.viewmodel.questions[question_id];

        // Ensure answers array for group exists
        if (!angular.isArray(group.answers)) {
          group.answers = [];
        }

        // Replace contents of existing array to maintain reference for angular bindings.
        group.answers.splice(0, group.answers.length, ...answers);
      });

      /**
       * Aggregate and current question stats.
       */

      const currentAnswerGroup = answer_groups[$scope.viewmodel.currentQuestion?.question_id] || {
        answers: [],
      };
      $scope.viewmodel.totalPlayers = player_sessions.length;
      $scope.viewmodel.currentPlayersAnswered = currentAnswerGroup.answers.length;
      $scope.viewmodel.currentPlayersCorrect = 0; // Set below

      // Loop over player_answers for current question:
      // * Set the current_answer field on appropriate players.
      // * Count # of correct answers.
      _.forEach(currentAnswerGroup.answers, (player_answer) => {
        player_answer.player.current_answer = player_answer;
        if (player_answer.correct) {
          $scope.viewmodel.currentPlayersCorrect++;
        }
      });
    };

    $scope.formatWBS = function (tables) {
      // Populate session data into WBS tables
      const gameMeta = $scope.viewmodel.game.meta;
      const scoreTables = tables.scoreLabels;
      const choicesTable = tables.choiceLabels;

      // Reset sessions' values from score & choices tables
      // eslint-disable-next-line no-restricted-syntax
      for (const round in scoreTables) {
        // eslint-disable-next-line no-restricted-syntax
        for (const label in scoreTables[round]) {
          scoreTables[round][label].sessions = [];
        }
      }
      // eslint-disable-next-line no-restricted-syntax
      for (const label in choicesTable) {
        choicesTable[label].sessions = [];
      }

      const { player_sessions } = $scope.viewmodel.session_data;
      player_sessions.forEach(({
        organization, employee_id, email, meta: sessionMeta,
      }) => {
        // Populate score tables with session scores
        for (let i = 0; i < gameMeta.A_Rounds; i++) {
          scoreTables[`round${i + 1}`].teamName.sessions.push(organization);
          const teamId = employee_id || email;
          scoreTables[`round${i + 1}`].teamId.sessions.push(teamId);
          const roundScore = sessionMeta[`Round ${i + 1}`];
          // eslint-disable-next-line no-restricted-syntax
          for (const meter in gameMeta.Meters) {
            let meterScore;
            // eslint-disable-next-line no-cond-assign
            if (roundScore && (meterScore = sessionMeta[`Round ${i + 1}`][meter])) {
              scoreTables[`round${i + 1}`][meter].sessions.push(meterScore);
            } else {
              scoreTables[`round${i + 1}`][meter].sessions.push(' ');
            }
          }
        }

        // Populate choices table with session choices
        // eslint-disable-next-line no-restricted-syntax
        for (const label in choicesTable) {
          if (label.indexOf('_teamName') > 0) {
            choicesTable[label].sessions.push(organization);
          } else if (label.indexOf('_teamId') > 0) {
            const teamId = employee_id || email;
            choicesTable[label].sessions.push(teamId);
          } else if (sessionMeta[label]) {
            choicesTable[label].sessions.push(sessionMeta[label]);
          } else {
            choicesTable[label].sessions.push(' ');
          }
        }
      });
    };

    $scope.processWBSGameMeta = function (gameMeta) {
      // Team header labels
      const scoreLabels = {};
      const choiceLabels = {};

      // Subdivide score based on number of action choice rounds
      for (let i = 0; i < gameMeta.A_Rounds; i++) {
        scoreLabels[`round${i + 1}`] = {};
        scoreLabels[`round${i + 1}`].teamName = { labels: [`Round ${i + 1}`], sessions: [] };
        scoreLabels[`round${i + 1}`].teamId = { labels: ['&nbsp;'], sessions: [] };
        // eslint-disable-next-line no-restricted-syntax
        for (const meter in gameMeta.Meters) {
          scoreLabels[`round${i + 1}`][meter] = { labels: [meter], sessions: [] };
        }
      }

      // Read the game meta to determine the structure of the Choices section
      choiceLabels.A_teamName = { labels: ['&nbsp;', '&nbsp;'], sessions: [] };
      choiceLabels.A_teamId = { labels: ['&nbsp;', '&nbsp;'], sessions: [] };
      for (let i = 0; i < gameMeta.Actions.length; i++) {
        choiceLabels[`A${i + 1}`] = { labels: [`A${i + 1}`, gameMeta.A_Labels[i]], sessions: [] }; // S# + friendly label
      }

      // Arbitrary spacing between actions and scenarios to line up with destination worksheet
      const numSpaces = 4;
      for (let i = 0; i < numSpaces; i++) {
        choiceLabels[`Spacer${i}`] = { labels: ['&nbsp;', '&nbsp;'], sessions: [] };
      }

      for (let i = 0; i < gameMeta.S_Scores.length; i++) {
        // Provide spacing and labels for each scenario
        choiceLabels[`S${i + 1}_teamName`] = { labels: ['&nbsp;', '&nbsp;'], sessions: [] };
        choiceLabels[`S${i + 1}_teamId`] = { labels: [`S${i + 1}`, gameMeta.S_Labels[i]], sessions: [] }; // S# + friendly label

        // Populate each letter in column 2
        Object.keys(gameMeta.S_Scores[i]).forEach((letter) => {
          choiceLabels[`S${i + 1}${letter}`] = { labels: ['', letter], sessions: [] }; // Blank + letter
        });
      }

      return { choiceLabels, scoreLabels };
    };

    $scope.formatCurrentWagers = function () {
      const question_id = $scope.viewmodel.currentQuestion?.question_id;
      const { session_data } = $scope.viewmodel;
      const { player_sessions } = session_data;

      // Clear wagers object and bail out if there is no current question or player sessions object.
      if (question_id == null || player_sessions == null) {
        $scope.viewmodel.session_data.current_wagers = null;
        return;
      }

      // Ensure $scope current_wagers object exists
      if (!_.isPlainObject(session_data.current_wagers)) {
        session_data.current_wagers = {};
      }
      const { current_wagers } = session_data;

      // Ensure current_wagers object has clean state, while maintaining keys/references.
      if (!angular.isArray(current_wagers.players)) {
        current_wagers.players = [];
      } else {
        current_wagers.players.splice(0, current_wagers.players.length);
      }
      current_wagers.high = 0;
      current_wagers.low = 0;
      current_wagers.average = 0;

      // Store lookup path for current question wager in metadata
      const meta_lookup_path = ['meta', 'wagers', question_id];

      // Loop over player_sessions:
      // * Collect wager amounts and set them on the player_session object.
      // * Add players who have wagered to the current_wagers player list
      const allAmounts = [];
      _.forEach(player_sessions, (player) => {
        const amount = _.get(player, meta_lookup_path, null);
        player.current_wager = amount;
        if (amount != null) {
          allAmounts.push(amount);
          current_wagers.players.push(player);
        }
      });

      // Generate aggregate stats for each question
      current_wagers.high = _.max(allAmounts) || 0;
      current_wagers.low = _.min(allAmounts) || 0;
      current_wagers.average = (_.sum(allAmounts) || 0) / (allAmounts.length || 1);
    };

    $scope.getModeName = function (mode) {
      const i = $scope.data.yesno.findIndex((el) => el.id === mode);
      return i === -1 ? '' : $scope.data.yesno[i].name;
    };

    $scope.initializeInstructorSocket = function (slug, instructor_token = '') {
      $scope.killInstructorSocket();
      const socket = socketService.createInstructorSocket(slug, instructor_token);
      socketService.bindEventHandlers(socket, [
        {
          event: 'session:state',
          callback: ({ state }) => $scope.refreshInstructorState(state),
        },
        {
          event: 'instructor:session_live',
          callback: (session_data) => {
            StreamService.initialize(session_data);
            $scope.updateSessionStatus(session_data);
          },
        },
        {
          event: 'session:ended',
          callback: () => {
            // want to make sure this is only triggered for instructors that didn't trigger it
            if (!$scope.triggeredGameEnd) {
              const { session_group_id } = $scope.viewmodel;
              $state.go('v1.instructor.analytics', {
                session_group_id,
              });
            }
          },
        },
        ...StreamService.streams,
      ]);
      VILTWebsocketActionsService.setSocket(socket);
    };

    $scope.killInstructorSocket = function () {
      let socket = VILTWebsocketActionsService.getSocket();
      if (socket) {
        socket.removeAllListeners();
        socket.disconnect();
        socket = null;
        VILTWebsocketActionsService.setSocket(null);
      }
    };

    // This represents things that occur after direct user interaction ONLY now
    $scope.actions = {
      gameInitiate() {
        instructorService
          .initiate($scope.data.gameId, $scope.viewmodel.name, $scope.viewmodel.mode, $scope.data.muteGame)
          .then((g) => {
            $state.go('v1.instructor.game', {
              slug: g.game_state.slug,
            });
          });
      },

      gameEnd(sName, sParams, sOptions) {
        // if sName provided user has tried to navigate from page while the game is running
        const message = sName
          ? 'Navigating from the instructor game view will end the current session.'
          : 'Are you sure you want to end this session?';
        modalService
          .showModal(
            {
              title: 'End Session?',
              message,
              closeButton: 'No',
              actionButton: 'Yes',
            },
            {
              backdrop: true,
              keyboard: true,
              animation: false,
            },
          )
          .then(() => {
            $scope.viewmodel.currentPlayersAnswered = 0;
            $scope.viewmodel.currentPlayersCorrect = 0;
            const { session_group_id } = $scope.viewmodel;
            instructorService.end($scope.viewmodel.slug).then((g) => {
              $scope.triggeredGameEnd = true;
              $scope.viewmodel.name = null;
              $scope.data.gameUrl = null;
              $scope.setState(g.game_state);
              $timeout.cancel($scope.playerStatusTimer);
              $scope.VILTSocketService.broadcastState();
              $scope.VILTSocketService.sessionEnded();
              $timeout(() => {
                if (sName) {
                  $state.go(sName, sParams, sOptions);
                } else {
                  $state.go('v1.instructor.analytics', {
                    session_group_id,
                  });
                }
              });
            });
          })
          .catch(angular.noop);
      },

      copyUrl() {
        const override = envService.read('gameUrlOverride');
        const gameUrl = override
          ? `${override}${$scope.viewmodel.slug}`
          : gameService.getGameUrl($scope.viewmodel.game);
        return $scope.viewmodel.game.slug ? gameUrl : '';
      },

      copySuccess(name) {
        if ($scope.copyTimer) {
          $timeout.cancel($scope.copyTimer);
        }

        $scope.data.copied = name;

        $scope.copyTimer = $timeout(() => {
          $scope.data.copied = false;
        }, 1500);
      },
    };

    // This represents things that occur after direct user interaction ONLY now & leverages the websocket services
    $scope.socketActions = {
      // start of socket service commands - some are only for J!
      backToBoard() {
        $scope.viewmodel.currentPlayersAnswered = 0;
        $scope.viewmodel.currentPlayersCorrect = 0;
        $scope.VILTSocketService.backToBoard();
      },
      feedbackNext() {
        const { advanced_feedback_index } = $scope.viewmodel.game.game_state;
        $scope.VILTSocketService.setFeedbackIndex(advanced_feedback_index + 1);
      },
      gameStart() {
        $scope.VILTSocketService.start();
      },
      gameMute() {
        $scope.VILTSocketService.mute(!$scope.viewmodel.game.game_state.game_mute);
      },
      gameNext() {
        $scope.viewmodel.currentPlayersAnswered = 0;
        $scope.viewmodel.currentPlayersCorrect = 0;
        instructorService.next($scope.viewmodel.slug).then(() => {
          $scope.VILTSocketService.broadcastState();
        });
      },
      hideWager() {
        if ($scope.viewmodel.game.game_state.show_final_wager) {
          $scope.VILTSocketService.showFinalJeopardy();
        } else {
          $scope.VILTSocketService.hideWager();
        }
      },
      showAnswers() {
        $scope.VILTSocketService.showAnswers();
      },
      showClue() {
        $scope.VILTSocketService.showClue();
        $scope.triggerIntructorButtonDelay();
      },
      showCorrect() {
        $scope.VILTSocketService.showCorrect();
      },
      showLeaderboard() {
        $log.debug($scope.viewmodel);
        $scope.VILTSocketService.showLeaderboard(!$scope.viewmodel.game.game_state.show_leaderboard);
      },
      showPoll() {
        $scope.VILTSocketService.showPoll();
      },
      skipToFinalJpd() {
        modalService
          .showModal(
            {
              title: 'Skip to Final Jeopardy?',
              message: 'Are you sure you want to skip to Final Jeopardy?',
              closeButton: 'Cancel',
              actionButton: 'Yes',
              actionClass: 'danger',
            },
            {
              backdrop: true,
              keyboard: true,
              animation: false,
            },
          )
          .then(() => {
            // limit the interaction with the iframe to prevent additional question selection while skipping
            $scope.viewmodel.disableInstructorInteraction = true;
            $timeout(() => {
              $scope.viewmodel.disableInstructorInteraction = false;
            }, 3000);
            $scope.VILTSocketService.skipToFinalJpd();
          })
          .catch(angular.noop);
      },
    };

    $scope.visibility = {
      // doing it like this so that the page doesn't run 20 functions everytime a single change happens on the page
      // this will only run 20 functions everytime the game state changes
      calculateVariables() {
        const { variables, functions } = $scope.visibility;
        variables.showHideWagerButton = functions.showHideWagerButton();
        variables.showNextQuestionButton = functions.showNextQuestionButton();
        variables.showClueButton = functions.showClueButton();
        variables.showAnswerButton = functions.showAnswerButton();
        variables.showCorrectButton = functions.showCorrectButton();
        variables.showBackButton = functions.showBackButton();
        variables.showPollButton = functions.showPollButton();
        variables.showAdvFeedbackButton = functions.showAdvFeedbackButton();
        variables.showSkipToFinalJpdButton = functions.showSkipToFinalJpdButton();
        variables.showJeopardyLeaderboardButtonTrue = functions.showJeopardyLeaderboardButton(true);
        variables.showJeopardyLeaderboardButtonFalse = functions.showJeopardyLeaderboardButton(false);
        variables.showDefaultLeaderboardButton = functions.showDefaultLeaderboardButton();
      },
      variables: {
        showHideWagerButton: false,
        showNextQuestionButton: false,
        showClueButton: false,
        showAnswerButton: false,
        showCorrectButton: false,
        showBackButton: false,
        showPollButton: false,
        showAdvFeedbackButton: false,
        showSkipToFinalJpdButton: false,
        showJeopardyLeaderboardButtonTrue: false,
        showJeopardyLeaderboardButtonFalse: false,
        showDefaultLeaderboardButton: false,
      },
      functions: {
        showHideWagerButton() {
          if ($scope.viewmodel.game.game_state.show_final_wager && !$scope.viewmodel.game.game_state.show_clue) {
            return true;
          }

          if ($scope.data.dailyDoubles.indexOf($scope.viewmodel.game.game_state.question_id) === -1) {
            return false;
          }

          if ($scope.viewmodel.game.game_state.hide_modal) {
            return false;
          }

          if ($scope.viewmodel.game.game_state.show_clue) {
            return false;
          }

          if ($scope.viewmodel.game.game_state.show_answers) {
            return false;
          }

          if ($scope.viewmodel.game.game_state.show_correct) {
            return false;
          }

          if ($scope.viewmodel.game.game_state.back_to_board) {
            return false;
          }

          return true;
        },

        showNextQuestionButton() {
          if (!$scope.viewmodel.currentQuestion) {
            return false;
          }
          if ($scope.viewmodel.currentQuestion && $scope.viewmodel.currentQuestion.advanced_feedback.length > 0) {
            if ($scope.viewmodel.currentQuestion.question_type === 'poll') {
              return true;
            }
            // eslint-disable-next-line max-len
            if (
              $scope.viewmodel.currentQuestion.advanced_feedback.length - 1
              === $scope.viewmodel.game.game_state.advanced_feedback_index
            ) {
              return true;
            }
            // eslint-disable-next-line max-len
            if (
              $scope.viewmodel.currentQuestion.advanced_feedback.length - 1
              !== $scope.viewmodel.game.game_state.advanced_feedback_index
            ) {
              return false;
            }
          }
          if (!$scope.viewmodel.game.game_state.show_answers) {
            return false;
          }
          if (
            $scope.viewmodel.currentQuestion.question_type === 'poll'
            && $scope.viewmodel.currentQuestion.show_results
            && !$scope.viewmodel.game.game_state.show_poll
          ) {
            return false;
          }
          return true;
        },

        showClueButton() {
          if ($scope.viewmodel.game.game_state.show_answers) {
            return false;
          }

          if ($scope.viewmodel.game.game_state.show_correct) {
            return false;
          }

          if (!$scope.viewmodel.game.game_state.question_id) {
            return false;
          }

          if ($scope.viewmodel.game.game_state.show_clue) {
            return false;
          }

          if ($scope.viewmodel.game.game_state.back_to_board) {
            return false;
          }

          if ($scope.visibility.functions.showHideWagerButton()) {
            return false;
          }

          if ($scope.viewmodel.currentQuestion) {
            if ($scope.viewmodel.currentQuestion.image && $scope.viewmodel.currentQuestion.image.original) {
              return true;
            }

            if ($scope.viewmodel.currentQuestion.video && $scope.viewmodel.currentQuestion.video.url) {
              return true;
            }
          }

          return false;
        },

        showAnswerButton() {
          if (
            $scope.visibility.functions.showHideWagerButton()
            || $scope.forceInstructorButtonDisable
            || $scope.viewmodel.game.game_state.back_to_board
          ) {
            return false;
          }

          if (!$scope.viewmodel.currentQuestion) {
            return false;
          }

          if ($scope.viewmodel.game.game_state.show_answers) {
            return false;
          }

          if (!$scope.viewmodel.game.game_state.question_id) {
            return false;
          }

          if ($scope.viewmodel.game.game_state.show_correct) {
            return false;
          }

          if ($scope.viewmodel.currentQuestion && $scope.data.gameType === 'jeopardy') {
            if (
              $scope.viewmodel.currentQuestion.image
              && $scope.viewmodel.currentQuestion.image.original
              && !$scope.viewmodel.game.game_state.show_clue
            ) {
              return true;
            }

            if (
              $scope.viewmodel.currentQuestion.video
              && $scope.viewmodel.currentQuestion.video.url
              && !$scope.viewmodel.game.game_state.show_clue
            ) {
              return true;
            }

            if ($scope.visibility.functions.showClueButton()) {
              return true;
            }
          }

          if ($scope.viewmodel.game.game_state.show_clue || $scope.viewmodel.game.game_state.hide_modal) {
            return true;
          }

          if (
            $scope.viewmodel.game.game_state.back_to_board
            || $scope.viewmodel.game.game_state.advanced_feedback_index > 0
          ) {
            return false;
          }

          if ($scope.data.dailyDoubles.indexOf($scope.viewmodel.game.game_state.question_id) !== -1) {
            return false;
          }

          if ($scope.viewmodel.game.game_state.show_final_wager) {
            return false;
          }

          return true;
        },

        showCorrectButton() {
          if (!$scope.viewmodel.game.game_state.question_id) {
            return false;
          }

          if (!$scope.viewmodel.game.game_state.show_answers) {
            return false;
          }

          return true;
        },

        showBackButton() {
          if ($scope.viewmodel.game.game_state.back_to_board) {
            return false;
          }

          const { currentQuestion } = $scope.viewmodel;

          if (!currentQuestion) {
            return false;
          }

          if (
            currentQuestion.advanced_feedback.length > 0
            && currentQuestion.advanced_feedback.length - 1 === $scope.viewmodel.game.game_state.advanced_feedback_index
          ) {
            return true;
          }

          if (currentQuestion.advanced_feedback.length > 0 && $scope.viewmodel.game.game_state.show_correct) {
            return false;
          }

          if (!$scope.viewmodel.game.game_state.show_correct) {
            return false;
          }

          return true;
        },

        showPollButton() {
          if (!$scope.viewmodel.currentQuestion) {
            return false;
          }
          if ($scope.viewmodel.currentQuestion.question_type !== 'poll') {
            return false;
          }
          if (!$scope.viewmodel.game.game_state.show_answers) {
            return false;
          }
          if ($scope.viewmodel.game.game_state.show_poll) {
            return false;
          }
          if (!$scope.viewmodel.currentQuestion.show_results) {
            return false;
          }
          return true;
        },

        showAdvFeedbackButton() {
          if (!$scope.viewmodel.currentQuestion) {
            return false;
          }

          if ($scope.viewmodel.currentQuestion.question_type === 'poll') {
            return false;
          }

          if ($scope.viewmodel.currentQuestion.advanced_feedback.length === 0) {
            return false;
          }

          // eslint-disable-next-line max-len
          if (
            $scope.viewmodel.currentQuestion.advanced_feedback.length - 1
            === $scope.viewmodel.game.game_state.advanced_feedback_index
          ) {
            return false;
          }

          if ($scope.data.gameType !== 'jeopardy') {
            if (!$scope.viewmodel.game.game_state.show_answers) {
              return false;
            }
          }

          if ($scope.data.gameType === 'jeopardy') {
            if (!$scope.viewmodel.game.game_state.show_correct) {
              return false;
            }
          }
          return true;
        },

        showSkipToFinalJpdButton() {
          const { questions_answered } = $scope.viewmodel.game.game_state;
          const answeredQuestions = _.uniq(questions_answered).length;
          if ($scope.data.gameType !== 'jeopardy') {
            return false;
          }
          if (answeredQuestions === $scope.totalQuestionsJeopardy - 1) {
            // disable chance of 'show skip to finalJpd' button showing up in unwanted final jpd transition
            return false;
          }
          return (
            $scope.viewmodel.game.game_state.back_to_board
            && !$scope.viewmodel.game.game_state.show_leaderboard
            && !$scope.viewmodel.game.game_state.skip_to_final_jpd
            && $scope.data.finalQuestionId != null
            && $scope.viewmodel.game.game_state.question_id !== $scope.data.finalQuestionId
          );
        },
        showDefaultLeaderboardButton() {
          if ($scope.data.gameType === 'trivia') {
            if ($scope.viewmodel.currentQuestion) {
              // game hasn't been started yet
              if (!$scope.viewmodel.game.game_state.game_start) {
                return false;
              }
              // if instructor has timed out show leaderboard
              if (
                $scope.viewmodel.game.game_state.instructor_timeout === $scope.viewmodel.currentQuestion.question_id
              ) {
                return true;
              }
              // on a question with a timer and not on an advanced feedback step
              if ($scope.viewmodel.currentQuestion.time > 0 && $scope.viewmodel.game.game_state.show_answers) {
                if (!($scope.viewmodel.game.game_state.advanced_feedback_index >= 0)) {
                  return false;
                }
              }
              // question has no timer or we are on advanced feedback
              return true;
            }
            // at the end of the game
            return true;
          }
          return false;
        },
        showJeopardyLeaderboardButton(show) {
          // disable chance of 'show leaderboard' button showing up in unwanted final jpd scenarios
          if (show) {
            const { questions_answered, skip_to_final_jpd } = $scope.viewmodel.game.game_state;
            const answeredQuestions = _.uniq(questions_answered).length;
            if (answeredQuestions === $scope.totalQuestionsJeopardy - 1 || skip_to_final_jpd) return false;
          }
          return (
            $scope.viewmodel.game.game_state.back_to_board
            && $scope.data.finalQuestionId != null
            && $scope.viewmodel.game.game_state.question_id !== $scope.data.finalQuestionId
          );
        },
      },
    };

    const stateChangeAlert = $rootScope.$on(
      '$stateChangeStart',
      (event, toState, toParams, fromState, fromParams, options) => {
        if ($scope.viewmodel.game.game_state.game_start && toState.name !== 'v1.login') {
          event.preventDefault();
          $scope.actions.gameEnd(toState.name, toParams, options);
        }
      },
    );

    $scope.$on('$destroy', () => {
      stateChangeAlert();
      $scope.data.pollingEnabled = false;
      const socket = VILTWebsocketActionsService.getSocket();
      if (socket) {
        $timeout(() => {
          $scope.killInstructorSocket();
        }, 1500);
      }
      // cancel any outstanding session update $timeouts
      $timeout.cancel($scope.sessionUpdateTimeout);
      $timeout.cancel($scope.playerStatusTimer);
    });

    $window.onbeforeunload = function (e) {
      if ($scope.viewmodel.session_group_id) {
        e.preventDefault();
      }
    };

    $scope.initialize();
  },
]);
